// extracted by mini-css-extract-plugin
export default {"queryButton":"hjJU0 SBH5Z uSVJz","queryButtonText":"iMHUT AfLf3"};